/**
 * Cache de session du rapport d'un dossier AO.
 *
 * Partagé : la vue Dossiers AO l'écrit à chaque analyse, et d'autres écrans
 * (fiche candidat) peuvent y déposer un rapport fraîchement renvoyé par une
 * action, pour que la vue AO l'affiche sans relancer de scan.
 */

export const aoCacheKey = (id) => `ao_report_${id}`;

export const saveAoCache = (id, data) => {
  try { sessionStorage.setItem(aoCacheKey(id), JSON.stringify(data)); } catch (e) {}
};

export const readAoCache = (id) => {
  try { const s = sessionStorage.getItem(aoCacheKey(id)); return s ? JSON.parse(s) : null; } catch (e) { return null; }
};

/** Remplace le seul rapport, en conservant le reste de l'entrée (titre, besoins…). */
export const updateAoReportCache = (id, report) => {
  if (id == null || !report) return;
  const prev = readAoCache(id) || {};
  saveAoCache(id, { ...prev, report });
};
